module.exports = __webpack_public_path__ + "img/rank-table-girl-2.b76a39eb.jpg";